import { render, staticRenderFns } from "./PricingTableDesktopDetail.vue?vue&type=template&id=327be101&scoped=true&"
import script from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
export * from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327be101",
  null
  
)

export default component.exports